import { useEffect } from "react";
import { isSignedIn } from "../utils/authStorage";
import { getUserProfile } from "../API/profileAPI";

/**
 * Reconciles the local sign-in marker against the server, once per load.
 *
 * Clearing on 401 fixes the state only once something happens to make a
 * request. A visitor arriving from the marketing site to run an eligibility
 * check may not touch a protected endpoint for a long time, so the header sat
 * there claiming they were signed in while the session had long expired.
 *
 * One cheap authenticated call at boot settles it: if the cookie is gone or
 * expired the API answers 401, and the response interceptor clears the session
 * and notifies the UI. Nothing is done with the result here — the interceptor
 * owns the outcome, and this exists to provoke it.
 *
 * It runs only when the marker claims a session, so a signed-out visitor pays
 * nothing.
 */
export default function useSessionReconciliation() {
  useEffect(() => {
    if (!isSignedIn()) return;
    getUserProfile().catch(() => {
      // A 401 is handled by the interceptor. Anything else — offline, a 500 —
      // must NOT sign the user out: being unable to confirm a session is not
      // the same as being told it is invalid.
    });
  }, []);
}
